import type {
  PartnerStatusValue,
  PartnerUserStatusValue,
} from "@redotech/admin-sdk/rpc/schema/partners/shared";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { memo } from "react";

export const PartnerStatusBadge = memo(function PartnerStatusBadge({
  status,
}: {
  status: PartnerStatusValue | PartnerUserStatusValue;
}) {
  return status === "active" ? (
    <RedoBadge color="success" size="sm" text="Active" />
  ) : (
    <RedoBadge
      color="gray"
      size="sm"
      text={status === "suspended" ? "Suspended" : "Disabled"}
    />
  );
});
